import "./App.scss";
import { Route, Routes, useLocation } from "react-router-dom";
import { paths } from "./utils/paths";
import {
  Home,
  About,
  Blogs,
  BlogDetail,
  Services,
  ServiceDatail,
  Contact,
  ErrorPage,
} from "./pages/index.js";
import { useEffect } from "react";

function App() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);



  


  return (
    <Routes>
      <Route path={paths.HOME} element={<Home />} />
      <Route path={paths.ABOUT} element={<About />} />
      <Route path={paths.BLOGS} element={<Blogs />} />
      <Route path={paths.BLOGDETAIL} element={<BlogDetail />} />
      <Route path={paths.SERVICES} element={<Services />} />
      <Route path={paths.SERVICEDATAIL} element={<ServiceDatail />} />
      <Route path={paths.CONTACT} element={<Contact />} />
      <Route path="/info/:slug" element={<ServiceDatail />} />
      <Route path="/get-involved/:slug" element={<ServiceDatail />} />
      <Route path="/erro" element={<ErrorPage />} />
      <Route path="/*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
